<template>
  <div>
    <div
      v-if="$store.state.bannerMessage"
      class="bg-red-600 text-white text-center text-lg px-4 mb-3 w-full"
    >
      {{ $store.state.bannerMessage }}

      <div
        v-if="$store.state.bannerMessageLn2"
        class="bg-red-600 text-white text-center text-lg px-4 mb-3 w-full"
      >
        {{ $store.state.bannerMessageLn2 }}
      </div>
    </div>
    <client-only>
      <div id="top" class="bg-blue-900 text-white md:mb-2">
        <div class="container mx-auto">
          <Horizontal justify="fill">
            <nuxt-link
              to="/"
              tag="button"
              class="w-full md:w-auto hover:text-blue-200 px-6 py-2 text-white inline-flex items-center"
            >
              <unicon name="arrow-left" fill="currentColor"></unicon>
              <span>Back to Search</span>
            </nuxt-link>
          </Horizontal>
        </div>
      </div>
      <div class="container mx-auto px-2 lg:px-6 py-4 md:py-6">
        <Header />
        <Nuxt />
      </div>
      <Footer />
    </client-only>
  </div>
</template>

<script>
import Header from '~/components/Header/Header.vue'
import Footer from '~/components/Footer/Footer.vue'
import Horizontal from '~/components/PageElements/Horizontal.vue'
import { qlikAssetsHead } from '~/mixins/qlikHead'

export default {
  components: {
    Header,
    Footer,
    Horizontal
  },
  head() {
    return qlikAssetsHead(this.$config)
  }
}
</script>

<style></style>
